import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const AmericanFootballIcon = observer(
    'AmericanFootballIcon',
    ({ className, onClick }: PropsType): JSX.Element => {
        return (
            <SvgElement
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                fill='none'
                viewBox='0 0 24 24'
                className={className}
                onClick={onClick}
            >
                <path
                    fill='#FFFFFF'
                    fillRule='evenodd'
                    d='M3.258 21.14a.636.636 0 0 1-.412-.412c-.663-2.101-.917-4.131-.82-6.03a.642.642 0 0 1 .027-.42C2.586 7.548 7.567 2.556 14.305 2.04a.635.635 0 0 1 .265-.038h.026a.644.644 0 0 1 .078.014c1.904-.099 3.943.157 6.056.828a.636.636 0 0 1 .412.412c.647 1.979.933 4.056.84 6.135l.002.012a.628.628 0 0 1-.359.624.638.638 0 0 1-.308.066c-3.792.265-7.104-2.575-7.418-6.381a6.925 6.925 0 0 1-.02-.355C8.212 4.022 4.026 8.189 3.36 13.87a6.967 6.967 0 0 1 6.757 6.768c5.036-.582 8.82-3.93 10.108-8.462a.634.634 0 0 1 .785-.43c.335.094.525.449.43.784-1.476 5.186-5.93 9.007-11.802 9.427a.633.633 0 0 1-.274.017c-1.907.102-3.96-.154-6.105-.834Zm5.588-.415a5.701 5.701 0 0 0-5.577-5.586c-.037 1.549.179 3.192.685 4.893 1.71.509 3.35.727 4.892.693Zm11.53-11.898a5.701 5.701 0 0 1-5.234-5.56c1.55-.037 3.193.179 4.892.685a15.84 15.84 0 0 1 .696 4.893 5.703 5.703 0 0 1-.354-.018Z'
                    clipRule='evenodd'
                />
                <path
                    fill='#39B54A'
                    d='M8.822 14.53a.64.64 0 0 0 1.09.444l.5-.5.5.5c.119.12.276.182.446.183h-.004.007-.003c.17 0 .333-.07.452-.19a.63.63 0 0 0 0-.892l-.5-.5.684-.684.5.5c.12.12.277.183.446.184h-.003.006-.003c.17-.001.333-.07.453-.19a.63.63 0 0 0 0-.893l-.5-.5.683-.684.5.5c.12.12.277.183.447.184h-.003.006-.003c.17 0 .333-.07.453-.19a.63.63 0 0 0 0-.893l-.5-.5.5-.5a.638.638 0 0 0 0-.899.638.638 0 0 0-.9 0l-.5.5-.5-.5a.638.638 0 0 0-.899 0 .638.638 0 0 0 0 .9l.5.5-.683.683-.5-.5a.638.638 0 0 0-.9 0 .638.638 0 0 0 0 .899l.501.5-.684.684-.5-.5a.638.638 0 0 0-.899 0 .638.638 0 0 0 0 .899l.5.5-.5.5a.647.647 0 0 0-.19.456Z'
                />
            </SvgElement>
        );
    }
);
